import { Outlet } from "react-router-dom";

/** Full-viewport telehealth control surface - no sidebar or app chrome. */
export default function TelehealthStandaloneLayout() {
  return (
    <div className="app-shell relative flex h-screen flex-col overflow-hidden bg-background">
      <main className="relative min-h-0 flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
